<div class="client_business_list">
  <div class="client_business_header">
    <div class="client_business_details_info">Clients Businesses</div>
  </div>
  <div class="client_business_search">
    <mat-form-field class="client_business_form_fields" appearance="outline">
      <input matInput type="text" placeholder="Search"(input)="applyFilter($event)"/>            
      <mat-icon matSuffix style="color: black;">search</mat-icon>
    </mat-form-field>
  </div>

    <div *ngIf="!dataprsent" style="text-align: center;">
      <img class="client_image" alt="client_image" src="assets/svg/search.svg" >
      <div style="font-size: 35px;font-family: var(--font);line-height: 1;color: grey;">Result Not Found</div>
      <div style="font-size: 22px;font-family: var(--font);line-height: 1;color: grey;">The Information is not available at this moment</div>
    </div>

  <div *ngIf="dataprsent" class="client_business_details">
    <div class="client_business_table_details">
      <!-- Applying global table styles -->
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Business Name Column -->
        <ng-container matColumnDef="ClientName">
          <th mat-header-cell *matHeaderCellDef>Client Name</th>
          <td mat-cell *matCellDef="let element">
            <div class="client_business_profile_container">
              <img [src]="element.ClientPhoto" alt="Profile Photo" *ngIf="element.isImageAvailable" class="client_business_profile_photo" />
              <span *ngIf="!element.isImageAvailable" class="manager_image_text">{{element.ClientImageText}}</span>
              <span>{{element.ClientFullName}}</span>
            </div>
          </td>
        </ng-container>

        <!-- Business Name Column -->
        <ng-container matColumnDef="ClientBusinessName">
          <th mat-header-cell *matHeaderCellDef>Business Name</th>
          <td mat-cell *matCellDef="let element">{{element.BusinessName}}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="ClientEmail">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{element.ClientEmail}}</td>
        </ng-container>

        <!-- Mobile Number Column -->
        <ng-container matColumnDef="ClientNumber">
          <th mat-header-cell *matHeaderCellDef>Mobile No</th>
          <td mat-cell *matCellDef="let element">{{element.ClientMobileNumber}}</td>
        </ng-container>

        <!-- Created On Column -->
        <ng-container matColumnDef="Created_On">
          <th mat-header-cell *matHeaderCellDef>Added On</th>
          <td mat-cell *matCellDef="let element">{{element.CreatedOn_text}}</td>
        </ng-container>

        <!-- Permission Type Column -->
        <ng-container matColumnDef="ClientPermissionType">
          <th mat-header-cell *matHeaderCellDef>Permission Type</th>
          <td mat-cell *matCellDef="let element">{{element.PermissionType}}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{element.Status}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
